export default {
    en: {
      global: {
        MapSave: 'Save Map Settings',
        ChangeLanguage: 'Change Lanuage',
        ChangeMap: 'Change Map Type',
        MapSatellite: 'Satellite Map',
        MapRoad:  'Road Map',
        hello: 'Work Dispatching and Tracking',
        welcome: 'Welcome, {name}',
        yourLanguage: 'Your language is {name}',
        Language: 'Language',
        English: 'English',
        German: 'German',
        Logout: 'Logout',
        
        UserEmail: 'User Email',
        YourRegistredEmail: 'Your registrierted email addresse',
        Password: 'Password',
        PasswordHelper: 'Your password',
        PleaseCheckEntries: 'Please check your entries',
        Login: 'Login',
        WorkingHours: 'Working Hours',
        DateFrom: 'Date From',
        DateTo: 'Date To',
        MainMenu: 'Main Menu',
        WorkTracking: 'Work Tracking',
        CaptureEvent: 'Capture Event',
        Journal: 'Journal',
        SatelliteMap: 'Satellite Map',
        GeoRegions: 'Geo Regions',
        GeoRegion: 'Geo Region',
        Administration: 'Administration',
        DistributeOrders: 'Distribute Orders',
        DefineWork: 'Define Work',
        ChangePassword: 'Change My Password',
        WorkSummary: 'Work Summary',
        EventSummary: 'Event Summary',
        ReportsAnalytics: 'Reports & Analytics',
        WorkJournal: 'Work Journal',
        WorkJournalMatrix: 'Work Journal Matrix',
        WorkJournalDrill: 'Work Journal Drill',
        WorkJournalProduct: 'Work Journal Product',
        WorkJournalRegion: 'Work Journal Region',
        Logout: 'Logout',
        GpsPosition: 'GPS Position',
        Update: 'Update',
        Meter: 'Meter',
        WorkStart: 'Work Start',
        WorkEnd: 'Work End',
        Assigned: 'Assigned',
        All: 'All',
        AssignedWork: 'Assigned Work',
        Comment: 'Comment',
        Pause: 'Pause',
        Done: 'Done',
        TakeOrder:'Take the Order',
        StartWork: 'Start Work',
        SelectWork: 'Select Work',
        SelectGeoRegion: 'Select Geo Region',
        Finish: 'Finish',
        WorkStarted: 'Work Started',
        WorkEnded: 'Work Ended',
        NoConnection:'No connection, end of work could not be recorded!',
        GpsError: 'GPS error. Please check on your GPS is turned on.',
        EndWork: 'End Work',
        Stop: 'Stop',
        Finish: 'Finish',
        WorkJournal: 'Work Journal',
        HourMin5: 'Hr:Min (+5)',
        Field: 'Field',
        Fields: 'Fields',
        Task: 'Task',
        EventJournal: 'Event Journal',
        Edit: 'Edit',
        Delete: 'Delete',
        Duplicate: 'Duplicate',
        EditWork: 'Edit Work',
        Save: 'Save',
        WorkChanged: 'Entry Changed',
        DeleteEntry:'Delete Entry',
        DeleteEntryQuestion:'Do you want to delete this entry?',
        EntryDeleted: 'Entry deleted',
        WorkDuplicated: 'Work duplicated',
        NewEntrys: 'New Entrys',
        NewEntry: 'New Entry',
        Map: 'Map',
        FullScreen: 'Full Screen',
        Close: 'Close',
        EditEvent: 'Edit Event',
        ProcessEvent: 'Process Event',
        EventTime: 'Event Time',
        EventType: 'Event Type',
        MarkAsProcessed:'Mark as Processed',
        Cancel: 'Cancel',
        DateTime: 'Date Time',
        Picture: 'Picture',
        QrScan: 'QR Scan',
        Summary: 'Summary',
        PeriodOfTime: 'Period of time',
        Month: 'Month',
        Week: 'Week',
        Day: 'Day',
        CurrentWeek: 'Current Week',
        DaysOfWeek: 'Mo,Tu,We,Th,Fr,Sa,Su',
        CurrentOrders: 'Open Orders',
        LastOrders: 'Last Completed Orders',
        Created: 'Created',
        Work: 'Work',
        People: 'People',
        EnterNewOrders: 'Enter New Orders',
        Product: 'Product',
        Work: 'Work',
        OrderDistributed: 'Order Distributed',
        WorkResourcesDefineManage: 'Work and Resources Define and Manage',
        WorkResourceEdit: 'Work or resource editing',
        Description: 'Description',
        NoAssignableWork: 'No assignable work (resources)',
        CostFix: 'Cost Fix',
        CostHa: 'Cost hectares',
        CostHour: 'Cost per Hour',
        DefineNewWorkResource: 'Define new Work or Resource', 
        Under: 'Under',
        ManageEmployees: 'Manage Employees',
        EditEmployee: 'Edit Employee',
        InsertEmployee: 'Insert Employee',
        CurrentEmployees: 'Current Employees',
        NewEmployee: 'Employee+',
        Employee: 'Employee',
        Employees: 'Employees',
        Name: 'Name',
        NameFirst: 'First Name',
        Category: 'Category',
        Address: 'Address',
        HourlyWage: 'hourly wage',
        MonthlyWage: 'Monthly wage',
        HoursMonth: 'Hours a month',
        Active: 'Active',
        EntryRequired: 'This entry is required',
        InvalidEmail: 'Invalid e-mail address',
        NotSafeEnugh: 'Not safe enugh',
        EmailAlreadyRecorded:'This email is already recorded',
        ManageProducts: 'Manage Products',
        ManageEventTypes: 'Manage Event Types',
        NewProduct: 'New Product',
        NewProductGroup: 'New Product Group',
        NewEventType: 'New Event Type',
        OldPassword: 'Old Password',
        NewPassword: 'New Password',
        NewPasswordRepeat: 'Repeat new password',
        PasswordNotEqual:'Password not equal',
        PasswordUpdated: 'Password Updated',
        OldPasswordNotValid: 'Old password is not valid',
        ShowAll:'Show All',

        EditGeoRegion: 'Edit Geo Region',
        GeoRegionType: 'Geo Region Art',
        Ground: 'Ground',
        PlantingYear: 'Planting Year',
        PlantDistanceMeter: 'Plant Distance Meter',
        RowsWidthMeters: 'Rows width meters',
        PlantsCapital: 'Plants Capital',
        AmortizationYear: 'Amortization Year',
        EditGeoRegionMap: 'Edit Geo Region on Map',
        NewSubGeoRegion: 'Insert New Sub Geo Region',
        NewGeoRegion: 'New Geo Region',
        DrawOnMap:'Draw on Map',
        Unfinished: 'Unfinished',
        Processed: 'Processed',
        By:'By',
        ProcessedBy: 'Processed By',
        ProcessedComment: 'Processed Comment',
        ResourceTemlate: 'Resource Template',
        NewResourceTemlate: 'New Resource Template',
        ResourceTemplateList: 'Resource Template List',
        AllocableWork: 'Allocable Work',
        Resource: 'Resource',
        Workgroup: 'Workgroup',
        PerWorkEntry: 'Per Work Entry',
        PerAssignment: 'Per Assignment / Order',
        PerDay: 'Per 24 Hours',
        WorkReport: 'Work Report',
        ResourceReport: 'Resource Report',
        EnterYield: 'Enter Yield',
        HarvestReorded:'harvest was recorded',
        Quantity: 'Kilo',
        Quality: 'Oechsle',
        Date: 'Date',
        SelectField: 'Select Field',
        Hectare: 'Hectare',
        Percent: 'Percent',
        Total: 'Total',
        YieldJournal: 'Yield Journal',
        ThisMonth: 'This Month',
        PreviousMonth: 'Previous Month',
        NextMonth: 'Next Month',
        EmployeeJournal: 'Employee Journal',
        DistributionWeightFactor: 'Distribution Weight Factor',
        WeightFactor: 'Weight Factor',
        CostBill: 'Geo Cost Bill',
        CostBillProduct: 'Product Cost Bill',
        RecalculateRedistribute: 'Recalculate and redistribute',
        AllProducts: 'All Products',
        OrderJournal: 'Order Journal',
        CloseTask:'Close Task',
        CloseTaskQuestion:'Do you want to close this task?',
        ReopenTask:'Reopen Task',
        ReopenTaskQuestion:'Do you want to reopen this task?',
        Open: 'Open',
        Completed: 'Completed',
        DuplicateGeoregions: "Duplicate georegions",
        NewName: "New Name",
        Duplicate: "Duplicate",
        GeoregionsDuplicated: "Georegions Duplicated",
        ProductGroup: "Product Group",
        Remove: "Remove",
        AssignedProducts: "Assigned Products",
        AssignProduct: "Assign Product",
        Assign: "Assign",
        French: "French",
        Italian: "Italian",
        Spanish: "Spanish",

        InstallExplain: "This app can be installed on your PC or mobile device. This will allow this web app to look and behave like any other installed app.",
        InstallHeader: "Install on your PC or Mobile Device",
        InstallButtonText: "Install as App",
        InstallIosInfotext: "Tap the share button and then 'Add to Homescreen'",

        AddOverlay: 'Add Overlay',
        RemoveOverlay: 'Remove Overlay',
        MapSettingsSaved: 'Map settings saved',
        ResourceCostFlexible: 'Resource Costs Flexible',

        ExcelAnalytics: "Excel - Analytics",
        ExcelMobileMessage: "Excel Analytics builds on top of Excel Pivot Tables. Unfortunately they are not working well on the mobile versions of Excel. To use these features, please use a desktop web browser.",
        ExcelReports: "Excel Reports",
        UploadExcelTemplate: "Upload new Excel Template",
        DownloadExcel: "Download Excel",
        Yield: "Yield",
        NewExcelReportName: "New Excel Report Name",
        DeleteExcelTemplate: "Delete this Excel Template",
        ExcelTemplateDeleted: "Excel Template Deleted",
        DeleteExcelTemplateQuestion: "Do you want to delete this this Excel Template?",
        UploadOk: "Template has been installed, it can be selected and executed now.",

        

      }
    },
    de: {
     global: {
      MapSave: 'Karte Einstellungen Speichern',
      ChangeLanguage: 'Sprache Aendern',
      ChangeMap: 'Karten Type Aendern',
      MapSatellite: 'Swissimage',
      MapRoad:  'Swisstopo',
      hello: 'Arbeits Verteilung und Erfassung',
      welcome: 'Willkommen, {name}',
      yourLanguage: 'Ihre Sprache ist {name}',
      Language: 'Sprache',
      English: 'Englisch',
      German: 'Deutsch',
      Logout: 'Logout',
      UserEmail: 'Benutzer Email',
      YourRegistredEmail: 'Ihre registrierte Email Addresse',
      Password: 'Passwort',
      PasswordHelper: 'Ihr Passwort',
      PleaseCheckEntries: 'Bitte überprüfen Sie Ihre Eingaben',
      Login: 'Anmeldung',
      WorkingHours: 'Arbeitszeiten',
      DateFrom: 'Datum Von',
      DateTo: 'Datum Bis',
      MainMenu: 'Haupt Menü',
      WorkTracking: 'Arbeit Erfassen',
      CaptureEvent: 'Ereigniss Erfassen',
      Journal: 'Journal',
      SatelliteMap: 'Satellitenkarte',
      GeoRegions: 'Geo Regionen',
      GeoRegion: 'Geo Region',
      Administration: 'Verwalten',
      DistributeOrders: 'Aufträge Verteilen',
      DefineWork: 'Arbeiten Definieren',
      ChangePassword: 'Mein Passwort Ändern',
      WorkSummary: 'Arbeits Übersicht',
      EventSummary: 'Ereignis Übersicht',
      ReportsAnalytics: 'Berichte & Auswertungen',
      WorkJournal: 'Arbeits Journal',
      WorkJournalMatrix: 'Arbeits Journal Matrix',
      WorkJournalDrill: 'Arbeits Journal Drill',
      WorkJournalProduct: 'Arbeits Journal Produkt',
      WorkJournalRegion: 'Arbeits Journal Region',
      Logout: 'Ausloggen',
      GpsPosition: 'GPS Position',
      Update: 'Update',
      Meter: 'Meter',
      WorkStart: 'Arbeits Beginn',
      WorkEnd: 'Arbeits Ende',
      Assigned: 'Zugeteilte',
      All: 'Alle',
      AssignedWork: 'Zugeteilte Arbeiten',
      Comment: 'Kommentar',
      Pause: 'Pause',
      Done: 'Erledigt',
      TakeOrder:'Auftrag übernehmen',
      StartWork: 'Arbeit Starten',
      SelectWork: 'Arbeiten Selektieren',
      SelectGeoRegion: 'Geo Region Selektieren',
      Finish: 'Beenden',
      WorkStarted: 'Arbeit start erfasst',
      WorkEnded: 'Arbeit ende erfasst',
      NoConnection:'Keine Verbindung, Arbeitsende konnte nicht erfasst werden!',
      GpsError: 'GPS Error. Bitte überprüfen sie on Ihr GPS Eingeschaltet ist.',
      EndWork: 'Arbeit Beenden',
      Stop: 'Beenden',
      Finish: 'Erledigt',
      WorkJournal: 'Arbeits Journal',
      HourMin5: 'Std:Min (+5)',
      Field: 'Parzelle',
      Fields: 'Parzellen',
      Task: 'Aufgabe',
      EventJournal: 'Ereignis Journal' ,
      Edit: 'Editieren',
      Delete: 'Löschen',
      Duplicate: 'Duplizieren',
      EditWork: 'Arbeit Editieren',
      Save: 'Speichern',
      WorkChanged: 'Eintrag geändert',
      DeleteEntry:'Eintrag Löschen',
      DeleteEntryQuestion:'Wollen sie diesen Eintrag löschen?',
      EntryDeleted: 'Eintrag gelöscht',
      WorkDuplicated: 'Arbeit dupliziert',
      NewEntrys: 'Neue Einträge',
      NewEntry: 'Neuer Eintrag',
      Map: 'Karte',
      FullScreen: 'Vollbild',
      Close: 'Schliessen',
      EditEvent: 'Event Editieren',
      ProcessEvent: 'Event Bearbeiten',
      EventTime: 'Event Zeit',
      EventType: 'Event Art',
      MarkAsProcessed:'Als bearbeitet Markieren',
      Cancel: 'Abbrechen',
      DateTime: 'Datum Zeit',
      Picture: 'Bild',
      QrScan: 'QR Scan',
      Summary: 'Zusammenfassung',
      PeriodOfTime: 'Zeitspanne',
      Month: 'Monat',
      Week: 'Woche',
      Day: 'Tag',
      CurrentWeek: 'Aktuelle Woche',
      DaysOfWeek: 'Mo,Di,Mi,Do,Fr,Sa,So',
      CurrentOrders:'Offene Aufträge',
      LastOrders: 'Letzte Abgeschlossenen Aufträge',
      Created: 'Erstellt',
      Work: 'Arbeit',
      People: 'Personen',
      EnterNewOrders: 'Neue Aufträge Erfassen',
      Product: 'Produkt',
      OrderDistributed: 'Auftrag Verteilt',
      WorkResourcesDefineManage: 'Arbeiten und Resourcen Definieren und Verwalten',
      WorkResourceEdit: 'Arbeit oder Resource Editieren',
      Description: 'Beschreibung',
      NoAssignableWork: 'Keine zuteilbare Arbeit (Resourcen)',
      CostFix: 'Kosten Fix',
      CostHa: 'Kosten Hektare',
      CostHour: 'Kosten pro Stunde',
      DefineNewWorkResource: 'Neu Arbeit oder Resource Erfassen',
      Under: 'Unter',
      ManageEmployees: 'Mitarbeiter Verwalten',
      EditEmployee: 'Mitarbeiter Editieren',
      InsertEmployee: 'Mitarbeiter Einfügen',
      CurrentEmployees: 'Aktuelle Mitarbeiter',
      NewEmployee: 'Mitarbeiter+',
      Employee: 'Mitarbeiter',
      Employees: 'Mitarbeiter',
      Name: 'Name',
      NameFirst: 'Vorname',
      Category: 'Kategorie',
      Address: 'Adresse',
      HourlyWage: 'Stundenlohn',
      MonthlyWage: 'Monatslohn',
      HoursMonth: 'Stunden pro Monat',
      Active: 'Aktiv',
      EntryRequired: 'Dieser Eintrag wird benötigt',
      InvalidEmail: 'Ungültige Email Addresse',
      NotSafeEnugh: 'Nicht sicher genug',
      EmailAlreadyRecorded:'DieseEmail ist schon erfasst',
      ManageProducts: 'Produkte Verwalten',
      ManageEventTypes: 'Event Arten Verwalten',
      NewProduct: 'Neues Produkt',
      NewProductGroup: 'Neue Produkt Gruppe',
      NewEventType: 'Neue Event Art',
      OldPassword: 'Altes Passwort',
      NewPassword: 'Neues Passwort',
      NewPasswordRepeat: 'Neues Passwort Wiederholen',
      PasswordNotEqual:'Passwort nicht gleich',
      PasswordUpdated: 'Passwort Geändert',
      OldPasswordNotValid: 'Altes Password ungültig',
      ShowAll:'Alles Anzeigen',

      EditGeoRegion: 'Geo Region Editieren',
      GeoRegionType: 'Geo Region Art',
      
      Ground: 'Unterlage',
      PlantingYear: 'Pflanzjahr',
      PlantDistanceMeter: 'Pflanzen Abstand Meter',
      RowsWidthMeters: 'Reihen Breite Meter',
      PlantsCapital: 'Pflanzenkapital',
      AmortizationYear: 'Amortisation Jahr',
      EditGeoRegionMap: 'Geo Region Auf Karte Editieren',
      NewSubGeoRegion: 'Neue Sub Geo Region Einfügen',
      NewGeoRegion: 'Neue Geo Region',
      DrawOnMap: 'Auf Karte Einzeichnen',
      Unfinished: 'Unbearbeitet',
      Processed: 'Bearbeitet',
      By: 'Von',
      ProcessedBy: 'Bearbeitet Von',
      ProcessedComment: 'Bearbeitet Kommentar',
      ResourceTemlate: 'Ressourcen Vorlage',
      NewResourceTemlate: 'Neue Resourcen Vorlage',
      ResourceTemplateList: 'Ressourcen Vorlagen',
      AllocableWork: 'Zuteilbare Arbeit',
      Resource: 'Ressource',
      Workgroup: 'Arbeitsgruppe',
      PerWorkEntry: 'Pro Arbeits Eintrag',
      PerAssignment: 'Pro Auftrag',
      PerDay: 'Pro 24 Stunden',
      WorkReport: 'Arbeits Bericht',
      ResourceReport: 'Resouren Bericht',
      EnterYield: 'Ertrag Erfassen',
      HarvestReorded:'Ernte wurde erfasst',
      Quantity: 'Kilo',
      Quality: 'Oechsle',
      Date: 'Datum',
      SelectField: 'Parzelle Selektieren',
      Hectare: 'Hektar',
      Percent: 'Prozent',
      Total: 'Total',
      YieldJournal: 'Ertrags Journal',
      ThisMonth: 'Aktueller Monat',
      PreviousMonth: 'Vorheriger Monat',
      NextMonth: 'Nächster Monat',
      EmployeeJournal: 'Mitarbeiter Journal',
      DistributionWeightFactor: 'Verteilungsgewichtsfaktor',
      WeightFactor: 'Gewichtsfaktor',
      CostBill: 'Geo Kosten Rechnung',
      CostBillProduct: 'Produkte Kosten Rechnung',
      RecalculateRedistribute: 'Neu Berechnen und Verteilen',
      AllProducts: 'Alle Produkte',
      OrderJournal: 'Auftrags Journal',
      CloseTask:'Auftrag Abschliessen',
      CloseTaskQuestion:'Wollen sie diesen Auftrag abschliessen?',
      ReopenTask:'Auftrag erneut öffnen',
      ReopenTaskQuestion:'Wollen sie diesen Auftrag erneut öffnen?',
      Open: 'Offen',
      Completed: 'Abgeschlossen',
      DuplicateGeoregions: "Georegionen Duplizieren",
      NewName: "Neuer Name",
      Duplicate: "Duplizieren",
      GeoregionsDuplicated: "Georegonen Dupliziert",
      ProductGroup: "Produkte Gruppe",
      Remove: "Entfernen",
      AssignedProducts: "Zugeordnete Produkte",
      AssignProduct: "Produkt Zuordnen",
      Assign: "Zuordnen",
      French: "Französich",
      Italian: "Italienisch",
      Spanish: "Spanisch",

      InstallExplain: "Diese App kann auf Ihrem PC oder Mobilgerät installiert werden. Dadurch kann diese Web-App wie jede andere installierte App aussehen und sich verhalten.",
      InstallHeader: "Installieren Sie auf Ihrem PC oder Mobilgerät",
      InstallButtonText: "Als App installieren",
      InstallIosInfotext: "Tippen Sie auf die Schaltfläche 'Teilen' und dann auf 'Zum Homescreen hinzufügen'.",

      AddOverlay: 'Overlay hinzufügen',
      RemoveOverlay: 'Entfernen Overlay',
      MapSettingsSaved: 'Karten Einstellungen gespeichert',

      ResourceCostFlexible: 'Resource Kosten Flexibel',

      ExcelAnalytics: "Excel - Analyse",
      ExcelMobileMessage: "Excel Analyse verwendet Excel-Pivot-Tabellen. Leider funktionieren diese in den mobilen Versionen von Excel nicht gut. Verwenden Sie bitte einen Desktop-Webbrowser um diese Funktionen zu verwenden.",
      ExcelReports: "Excel Berichte",
      UploadExcelTemplate: "Neue Excel-Vorlage hochladen",
      DownloadExcel: "Download Excel",
      Yield: "Ertrag",
      NewExcelReportName: "Neuer Excel Report Name",
      DeleteExcelTemplate: "Diese Excel Vorlage Löschen",
      ExcelTemplateDeleted: "Excel Vorlage Gelöscht",
      DeleteExcelTemplateQuestion: "Wollen sie diese Excel Vorlage löschen?",
      UploadOk: "Die Vorlage wurde installiert und kann jetzt ausgewählt und ausgeführt werden.",
      

    }   
  },
  fr: {
    global: {
      MapSave: 'Enregistrer les paramètres de la carte',
      ChangeLanguage: 'Changer la langue',
      ChangeMap: 'Changer le type de carte',
      MapSatellite: 'Carte satellite',
      MapRoad:  'Carte routière',
      hello: 'Répartition et saisie du travail',
      welcome: 'Bienvenue, {name}',
      yourLanguage: 'Votre langue est {name}',
      Language: 'Langue',
      English: 'Anglais',
      German: 'Allemand',
      Logout: 'Déconnexion',
      UserEmail: 'E-mail utilisateur',
      YourRegistredEmail: 'Votre adresse e-mail enregistrée',
      Password: 'Mot de passe',
      PasswordHelper: 'Votre mot de passe',
      PleaseCheckEntries: 'Veuillez vérifier vos données',
      Login: 'Inscription',
      WorkingHours: 'Horaires de travail',
      DateFrom: 'Date du',
      DateTo: 'Date jusqu\'au',
      MainMenu: 'Menu principal',
      WorkTracking: 'Saisir le travail',
      CaptureEvent: 'Saisir l\'évènement',
      Journal: 'Journal',
      SatelliteMap: 'Carte satellite',
      GeoRegions: 'Régions géographiques',
      GeoRegion: 'Région géographique',
      Administration: 'Gérer',
      DistributeOrders: 'Distribuer les ordres',
      DefineWork: 'Définir les travaux',
      ChangePassword: 'Modifier mon mot de passe',
      WorkSummary: 'Aperçu du travail',
      EventSummary: 'Aperçu de l\'évènement',
      ReportsAnalytics: 'Rapports et analyses',
      WorkJournal: 'Journal de travail',
      WorkJournalMatrix: 'Matrice du journal de travail',
      WorkJournalDrill: 'Exercice du journal de travail',
      WorkJournalProduct: 'Produit du journal de travail',
      WorkJournalRegion: 'Région du journal de travail',
      Logout: 'Se déconnecter',
      GpsPosition: 'Position GPS',
      Update: 'Mise à jour',
      Meter: 'Mètre',
      WorkStart: 'Début du travail',
      WorkEnd: 'Fin du travail',
      Assigned: 'Assignés',
      All: 'Tous',
      AssignedWork: 'Travaux assignés',
      Comment: 'Commentaire',
      Pause: 'Pause',
      Done: 'Terminé',
      TakeOrder:'Accepter l\'ordre',
      StartWork: 'Commencer le travail',
      SelectWork: 'Sélectionner les travaux',
      SelectGeoRegion: 'Sélectionner la région géographique',
      Finish: 'Terminer',
      WorkStarted: 'Début du travail saisi',
      WorkEnded: 'Fin du travail saisie',
      NoConnection:'Pas de connexion, la fin du travail n\'a pas pu être saisie !',
      GpsError: 'Erreur GPS. Veuillez vérifier si votre GPS est activé.',
      EndWork: 'Terminer le travail',
      Stop: 'Terminer',
      Finish: 'Terminé',
      WorkJournal: 'Journal de travail',
      HourMin5: 'Heure:min (+5)',
      Field: 'Parcelle',
      Fields: 'Parcelles',
      Task: 'Tâche',
      EventJournal: 'Journal de l\'évènement',
      Edit: 'Éditer',
      Delete: 'Supprimer',
      Duplicate: 'Dupliquer',
      EditWork: 'Editer le travail',
      Save: 'Enregistrer',
      WorkChanged: 'Entrée modifiée',
      DeleteEntry:'Supprimer l\'entrée',
      DeleteEntryQuestion:'Voulez-vous supprimer cette entrée ?',
      EntryDeleted: 'Entrée supprimée',
      WorkDuplicated: 'Travail dupliqué',
      NewEntrys: 'Nouvelles entrées',
      NewEntry: 'Nouvelle entrée',
      Map: 'Carte',
      FullScreen: 'Plein écran',
      Close: 'Fermer',
      EditEvent: 'Editer l\'évènement',
      ProcessEvent: 'Modifier l\'évènement',
      EventTime: 'Heure de l\'évènement',
      EventType: 'Type de l\'évènement',
      MarkAsProcessed:'Marquer comme modifié',
      Cancel: 'Annuler',
      DateTime: 'Date heure',
      Picture: 'Image',
      QrScan: 'Scan QR',
      Summary: 'Récapitulatif',
      PeriodOfTime: 'Période',
      Month: 'Mois',
      Week: 'Semaine',
      Day: 'Jour',
      CurrentWeek: 'Semaine en cours',
      DaysOfWeek: 'Lun,mar,mer,jeu,ven,sam,dim',
      CurrentOrders:'Ordres en cours',
      LastOrders: 'Derniers ordres terminés',
      Created: 'Créé',
      Work: 'Travail',
      People: 'Personnes',
      EnterNewOrders: 'Saisir de nouveaux ordres',
      Product: 'Produit',
      Work: 'Travaux',
      OrderDistributed: 'Ordre distribué',
      WorkResourcesDefineManage: 'Définir et gérer le travail et les ressources',
      WorkResourceEdit: 'Editer le travail ou la ressource',
      Description: 'Description',
      NoAssignableWork: 'Pas de travail assignable (ressources)',
      CostFix: 'Coûts fixes',
      CostHa: 'Coûts par hectare',
      CostHour: 'Coûts par heure',
      DefineNewWorkResource: 'Editer à nouveau le travail ou la ressource',
      Under: 'Sous',
      ManageEmployees: 'Gérer les employés',
      EditEmployee: 'Editer l\'employé',
      InsertEmployee: 'Insérer l\'employé',
      CurrentEmployees: 'Employés actuels',
      NewEmployee: 'Employé+',
      Employee: 'Employé',
      Employees: 'Employés',
      Name: 'Nom',
      NameFirst: 'Prénom',
      Category: 'Catégorie',
      Address: 'Adresse',
      HourlyWage: 'Salaire horaire',
      MonthlyWage: 'Salaire mensuel',
      HoursMonth: 'Heures par mois',
      Active: 'Actif',
      EntryRequired: 'Cette entrée est nécessaire',
      InvalidEmail: 'Adresse e-mail non valide',
      NotSafeEnugh: 'Pas assez sûr',
      EmailAlreadyRecorded:'E-mail déjà saisi',
      ManageProducts: 'Gérer les produits',
      ManageEventTypes: 'Gérer les types d\'évènements',
      NewProduct: 'Nouveau produit',
      NewProductGroup: 'Nouveau groupe de produits',
      NewEventType: 'Nouveau type d\'évènement',
      OldPassword: 'Ancien mot de passe',
      NewPassword: 'Nouveau mot de passe',
      NewPasswordRepeat: 'Répéter le nouveau mot de passe',
      PasswordNotEqual:'Mot de passe différent',
      PasswordUpdated: 'Mot de passe modifié',
      OldPasswordNotValid: 'Ancien mot de passe non valide',
      ShowAll:'Afficher tout',
      EditGeoRegion: 'Editer la région géographique',
      GeoRegionType: 'Type de région géographique',
      Ground: 'Sol',   
      PlantingYear: 'Année de plantation',
      PlantDistanceMeter: 'Distance entre les plantes en mètres',
      RowsWidthMeters: 'Largeur des rangées en mètres',
      PlantsCapital: 'Capital-plantes',
      AmortizationYear: 'Année d\'amortissement',
      EditGeoRegionMap: 'Editer la région géographique sur la carte',
      NewSubGeoRegion: 'Insérer une nouvelle sous-région géographique', 
      NewGeoRegion: 'Nouvelle sous-région géographique',
      DrawOnMap: 'Dessiner sur la carte',
      Unfinished: 'Non terminé',
      Processed: 'Traité',
      By: 'Par',
      ProcessedBy: 'Traité par',
      ProcessedComment: 'Commentaire traité',
      ResourceTemlate: 'Modèle de ressources',
      NewResourceTemlate: 'Nouveau modèle de ressources',
      ResourceTemplateList: 'Modèles de ressources',
      AllocableWork: 'Travail attribuable',
      Resource: 'Ressource',
      Workgroup: 'Groupe de travail',
      PerWorkEntry: 'Par entrée de travail',
      PerAssignment: 'Par ordre',
      PerDay: 'Par 24 heures',
      WorkReport: 'Rapport de travail',
      ResourceReport: 'Rapport de ressources',
      EnterYield: 'Saisir le rendement',
      HarvestReorded:'La récolte a été saisie',
      Quantity: 'Kilo',
      Quality: 'Oechsle',
      Date: 'Date',
      SelectField: 'Sélectionner la parcelle',
      Hectare: 'Hectare',
      Percent: 'Pourcent',
      Total: 'Total',  
      YieldJournal: 'Journal de rendement', 
      ThisMonth: 'Mois en cours',
      PreviousMonth: 'Mois précédent',
      NextMonth: 'Mois prochain',
      EmployeeJournal: 'Journal d\'employé',
      DistributionWeightFactor: 'Facteur du poids de distribution',
      WeightFactor: 'Facteur de distribution',
      CostBill: 'Geo Calcul des coûts',
      CostBillProduct: 'Produit Calcul des coûts',
      RecalculateRedistribute: 'Recalculer et distribuer',
      AllProducts: 'Tous les produits',
      OrderJournal: 'Journal d\'ordre',
      CloseTask:'Clôturer l\'ordre',  
      CloseTaskQuestion:'Voulez-vous clôturer cet ordre ?',
      ReopenTask:'Rouvrir l\'ordre',
      ReopenTaskQuestion:'Voulez-vous rouvrir cet ordre ?',
      Open: 'Ouvert',
      Completed: 'Terminé',
      DuplicateGeoregions: "Dupliquer les régions géographiques",
      NewName: "Nouveau nom",
      Duplicate: 'Dupliquer', 
      GeoregionsDuplicated: "Régions géographiques dupliquées",
      ProductGroup: 'Groupe de produits',
      Remove: "Supprimer",
      AssignedProducts: "Produits attribués",
      AssignProduct: "Attribuer le produit",
      Assign: "Attribuer",
      French: "Français",
      Italian: "Italien",
      Spanish: "Espagnol",

      InstallExplain: "Cette application peut être installée sur votre PC ou appareil mobile. Cela lui permet de ressembler et de se comporter comme n'importe quelle autre application installée.",
      InstallHeader: "Installer sur votre PC ou appareil mobile",
      InstallButtonText: "Installer en tant qu'application",
      InstallIosInfotext: "Appuyez sur le bouton 'Partager' puis sur 'Ajouter à l'écran d'accueil' .",
      
      AddOverlay: 'Ajouter Overlay',
      RemoveOverlay: 'Supprimer Overlay',
      MapSettingsSaved: 'Paramètres de la carte enregistrés',
      ResourceCostFlexible: 'Coûts des ressources flexibles',


      ExcelAnalytics: "Excel - Analyser",
      ExcelMobileMessage: "Excel Analysis utilise des tableaux croisés dynamiques Excel. Malheureusement, ceux-ci ne fonctionnent pas bien dans les versions mobiles d'Excel. Veuillez utiliser un navigateur Web de bureau pour utiliser ces fonctions.",
      ExcelReports: "Rapports Excel",
      UploadExcelTemplate: "Télécharger un nouveau modèle Excel",
      DownloadExcel: "Télécharger Excel",
      Yield: "Rendement",
      NewExcelReportName: "Nom du nouveau rapport Excel",
      DeleteExcelTemplate: "Supprimer ce modèle Excel",
      ExcelTemplateDeleted: "Modèle Excel supprimé",
      DeleteExcelTemplateQuestion: "Voulez-vous supprimer ce modèle Excel?",
      UploadOk: "Le modèle a été installé, il peut être sélectionné et exécuté maintenant.",

    }
  },
  it: {
    global: {
      MapSave: 'Salva impostazioni carta',
      ChangeLanguage: 'Cambia lingua',
      ChangeMap: 'Cambia tipo di mappa',
      MapSatellite: 'Mappa satellitare',
      MapRoad:  'Mappa stradale',
      hello: 'Distribuzione e registrazione dei lavori',
      welcome: 'Benvenuto {name}',
      yourLanguage: 'La Sua lingua è {name}',
      Language: 'Lingua',
      English: 'Inglese',
      German: 'Tedesco',
      Logout: 'Logout',
      UserEmail: 'E-mail utente',
      YourRegistredEmail: 'Il Suo indirizzo registrato',
      Password: 'Password',
      PasswordHelper: 'La Sua password',
      PleaseCheckEntries: 'La preghiamo di controllare i Suoi dati',
      Login: 'Accesso',
      WorkingHours: 'Orari di lavoro',
      DateFrom: 'Dal giorno',
      DateTo: 'Al giorno',
      MainMenu: 'Menù principale',
      WorkTracking: 'Registra lavoro',
      CaptureEvent: 'Registra evento',
      Journal: 'Agenda',
      SatelliteMap: 'Mappa satellitare',
      GeoRegions: 'Aree geografiche',
      GeoRegion: 'Area geografica',
      Administration: 'Gestisci',
      DistributeOrders: 'Distribuisci ordini',
      DefineWork: 'Definisci lavoro',
      ChangePassword: 'Modifica la mia password',
      WorkSummary: 'Prospetto del lavoro',
      EventSummary: 'Prospetto dell’evento',
      ReportsAnalytics: 'Rapporti e analisi',
      WorkJournal: 'Agenda di lavoro',
      WorkJournalMatrix: 'Agenda di lavoro Matrix',
      WorkJournalDrill: 'Agenda di lavoro Drill',
      WorkJournalProduct: 'Agenda di lavoro Prodotto',
      WorkJournalRegion: 'Agenda di lavoro Regione',
      Logout: 'Esci',
      GpsPosition: 'Posizione GPS',
      Update: 'Aggiornamento',
      Meter: 'Metri',
      WorkStart: 'Inizio dei lavori',
      WorkEnd: 'Fine dei lavori',
      Assigned: 'Assegnati',
      All: 'Tutti',
      AssignedWork: 'Lavori assegnati',
      Comment: 'Nota',
      Pause: 'Pausa',
      Done: 'Eseguito',
      TakeOrder:'Accetta ordine',
      StartWork: 'Inizia lavoro',
      SelectWork: 'Seleziona lavori',
      SelectGeoRegion: 'Seleziona area geografica',
      Finish: 'Termina',
      WorkStarted: 'Inizio dei lavori registrato',
      WorkEnded: 'Fine dei lavori registrata',
      NoConnection:'Connessione assente. Impossibile registrare la fine dei lavori!',
      GpsError: 'Errore GPS. Verificare che il GPS sia acceso.',
      EndWork: 'Termina lavoro',
      Stop: 'Termina',
      Finish: 'Eseguito',
      WorkJournal: 'Agenda di lavoro',
      HourMin5: 'Ore:Min (+5)',
      Field: 'Lotto',
      Fields: 'Lotti',
      Task: 'Compito',
      EventJournal: 'Diario degli eventi' ,
      Edit: 'Modifica',
      Delete: 'Elimina',
      Duplicate: 'Duplica',
      EditWork: 'Modifica lavoro',
      Save: 'Salva',
      WorkChanged: 'Voce modificata',
      DeleteEntry:'Elimina voce',
      DeleteEntryQuestion:'Desidera eliminare questa voce?',
      EntryDeleted: 'Voce eliminata',
      WorkDuplicated: 'Lavoro duplicato',
      NewEntrys: 'Nuove voci',
      NewEntry: 'Nuova voce',
      Map: 'Mappa',
      FullScreen: 'Schermo intero',
      Close: 'Chiudi',
      EditEvent: 'Modifica evento',
      ProcessEvent: 'Elabora evento',
      EventTime: 'Ora dell’evento',
      EventType: 'Tipo di evento',
      MarkAsProcessed:'Segna come processato',
      Cancel: 'Annulla',
      DateTime: 'Data ora',
      Picture: 'Immagine',
      QrScan: 'Scansiona QR',
      Summary: 'Riepilogo',
      PeriodOfTime: 'Intervallo di tempo',
      Month: 'Mese',
      Week: 'Settimana',
      Day: 'Giorno',
      CurrentWeek: 'Questa settimana',
      DaysOfWeek: 'Lun,mar,mer,gio,ven,sab,dom',
      CurrentOrders:'Ordini in sospeso',
      LastOrders: 'Ultimi ordini completati',
      Created: 'Creato',
      Work: 'Lavoro',
      People: 'Persone',
      EnterNewOrders: 'Registra nuovi ordini',
      Product: 'Prodotto',
      Work: 'Lavori',
      OrderDistributed: 'Ordine distribuito',
      WorkResourcesDefineManage: 'Definisci e gestisci lavori e risorse',
      WorkResourceEdit: 'Modifica lavoro o risorsa',
      Description: 'Descrizione',
      NoAssignableWork: 'Nessun lavoro assegnabile (risorse)',
      CostFix: 'Costi fissi',
      CostHa: 'Costi ettari',
      CostHour: 'Costi orari',
      DefineNewWorkResource: 'Inserisci nuovo lavoro o risorsa',
      Under: 'Sotto',
      ManageEmployees: 'Gestisci collaboratore',
      EditEmployee: 'Modifica collaboratore',
      InsertEmployee: 'Aggiungi collaboratore',
      CurrentEmployees: 'Collaboratore attuale',
      NewEmployee: 'Nuovo collaboratore',
      Employee: 'Collaboratore',
      Employees: 'Collaboratore',
      Name: 'Cognome',
      NameFirst: 'Nome',
      Category: 'Categoria',
      Address: 'Indirizzo',
      HourlyWage: 'Stipendio orario',
      MonthlyWage: 'Stipendio mensile',
      HoursMonth: 'Ore al mese',
      Active: 'Attivo',
      EntryRequired: 'Questa voce è richiesta',
      InvalidEmail: 'Indirizzo e-mail non valido',
      NotSafeEnugh: 'Non abbastanza sicuro',
      EmailAlreadyRecorded:'Questa e-mail è già registrata',
      ManageProducts: 'Gestisci prodotti',
      ManageEventTypes: 'Gestisci tipo di evento',
      NewProduct: 'Nuovo prodotto',
      NewProductGroup: 'Nuovo gruppo di prodotti',
      NewEventType: 'Nuovo tipo di evento',
      OldPassword: 'Vecchia password',
      NewPassword: 'Nuova password',
      NewPasswordRepeat: 'Ripeti nuova password',
      PasswordNotEqual:'La password non corrisponde',
      PasswordUpdated: 'Password modificata',
      OldPasswordNotValid: 'Vecchia password non valida',
      ShowAll:'Mostra tutto',
      EditGeoRegion: 'Modifica area geografica',
      GeoRegionType: 'Tipo di area geografica',
      Ground: 'Terreno',
      PlantingYear: 'Anno di impianto',
      PlantDistanceMeter: 'Metri di distanza tra piante',
      RowsWidthMeters: 'Metri di larghezza delle file',
      PlantsCapital: 'Capitale di piante',
      AmortizationYear: 'Anno di ammortamento',
      EditGeoRegionMap: 'Modifica area geografica sulla mappa',
      NewSubGeoRegion: 'Inserisci nuova sotto-area geografica',
      NewGeoRegion: 'Nuova area geografica',
      DrawOnMap: 'Traccia sulla mappa',
      Unfinished: 'Non completato',
      Processed: 'Processato',
      By: 'Da',
      ProcessedBy: 'Processato da',
      ProcessedComment: 'Nota elaborata',
      ResourceTemlate: 'Modello risorse',
      NewResourceTemlate: 'Nuovo modello risorse',
      ResourceTemplateList: 'Modelli risorse',
      AllocableWork: 'Lavoro assegnabile',
      Resource: 'Risorsa',
      Workgroup: 'Gruppo di lavoro',
      PerWorkEntry: 'Per voce di lavoro',
      PerAssignment: 'Per incarico',
      PerDay: 'Per 24 ore',
      WorkReport: 'Rapporto sul lavoro',
      ResourceReport: 'Rapporto sulle risorse',
      EnterYield: 'Registra resa',
      HarvestReorded:'Raccolto registrato',
      Quantity: 'Chili',
      Quality: 'Oechsle',
      Date: 'Data',
      SelectField: 'Seleziona lotto',
      Hectare: 'Ettaro',
      Percent: 'Percentuale',
      Total: 'Totale',
      YieldJournal: 'Agenda delle rese',
      ThisMonth: 'Questo mese',
      PreviousMonth: 'Mese precedente',
      NextMonth: 'Prossimo mese',
      EmployeeJournal: 'Agenda dei collaboratori',
      DistributionWeightFactor: 'Fattore di distribuzione del peso',
      WeightFactor: 'Fattore di distribuzione',
      CostBill: 'Geo Calcolo dei costi',
      CostBillProduct: 'Prodotti Calcolo dei costi',
      RecalculateRedistribute: 'Ricalcola e ridistribuisci',
      AllProducts: 'Tutti i prodotti',
      OrderJournal: 'Agenda degli ordini',
      CloseTask:'Chiudi ordine',
      CloseTaskQuestion:'Desidera chiudere questo ordine?',
      ReopenTask:'Riapri ordine',
      ReopenTaskQuestion:'Desidera riaprire questo ordine?',
      Open: 'Apri',
      Completed: 'Completato',
      DuplicateGeoregions: "Duplica aree geografiche",
      NewName: "Nuovo nome",
      Duplicate: "Duplica",
      GeoregionsDuplicated: "Aree geografiche duplicate",
      ProductGroup: "Gruppi di prodotti",
      Remove: "Rimuovi",
      AssignedProducts: "Prodotti assegnati",
      AssignProduct: "Assegna prodotto",
      Assign: "Assegna",
      French: "Francese",
      Italian: "Italiano",
      Spanish: "Spagnolo",

      InstallExplain: "Questa app può essere installata sul tuo PC o dispositivo mobile. Ciò consente a questa app web di apparire e comportarsi come qualsiasi altra app installata.",
      InstallHeader: "Installa sul tuo PC o dispositivo mobile",
      InstallButtonText: "Installa come app",
      InstallIosInfotext: "Tocca il pulsante 'Condividi', quindi 'Aggiungi alla schermata iniziale' .",

      AddOverlay: 'Aggiungi overlay',
      RemoveOverlay: 'Rimuovi Overlay',
      MapSettingsSaved: 'Impostazioni della mappa salvate',
      ResourceCostFlexible: 'Costi delle risorse flessibili',

      ExcelAnalytics: "Excel - Analizza",
      ExcelMobileMessage: "Excel Analysis utilizza tabelle pivot di Excel. Sfortunatamente, questi non funzionano bene nelle versioni mobili di Excel. Utilizzare un browser Web desktop per utilizzare queste funzioni.",
      ExcelReports: "Rapporti Excel",
      UploadExcelTemplate: "Carica un nuovo modello Excel",
      DownloadExcel: "Scarica Excel",
      Yield: "Prodotto",
      NewExcelReportName: "Nuovo nome rapporto Excel",
      DeleteExcelTemplate: "Elimina questo modello Excel",
      ExcelTemplateDeleted: "Modello Excel eliminato",
      DeleteExcelTemplateQuestion: "Vuoi eliminare questo modello Excel?",
      UploadOk: "Il modello è stato installato, può essere selezionato ed eseguito ora.",
    }
  },
  es: {
    global: {
      MapSave: 'Guardar configuración de mapa',
      ChangeLanguage: 'Cambiar de idioma',
      ChangeMap: 'Cambiar de tipo de mapa',
      MapSatellite: 'Mapa satélite',
      MapRoad:  'Mapa de calles',
      hello: 'Distribución y registro de las tareas',
      welcome: 'Bienvenido, {nombre}',
      yourLanguage: 'Seleccionar idioma {¨nombre}',
      Language: 'Idioma',
      English: 'Inglés',
      German: 'Alemán',
      Logout: 'Cerrar sesión',
      UserEmail: 'Correo electrónico',
      YourRegistredEmail: 'Su correo electrónico registrado',
      Password: 'Contraseña',
      PasswordHelper: 'Su contraseña',
      PleaseCheckEntries: 'Revise sus datos',
      Login: 'Iniciar sesión',
      WorkingHours: 'Horario de trabajo',
      DateFrom: 'Desde fecha',
      DateTo: 'Hasta fecha',
      MainMenu: 'Menú principal',
      WorkTracking: 'Introducir tarea',
      CaptureEvent: 'Introducir resultado',
      Journal: 'Diario',
      SatelliteMap: 'Mapa satélite',
      GeoRegions: 'Regiones geográficas',
      GeoRegion: 'Región geográfica',
      Administration: 'Administrar',
      DistributeOrders: 'Distribuir proyectos',
      DefineWork: 'Definir tarea',
      ChangePassword: 'Cambiar mi contraseña',
      WorkSummary: 'Resumen de la tarea',
      EventSummary: 'Resumen del evento',
      ReportsAnalytics: 'Informes y análisis',
      WorkJournal: 'Diario de trabajo',
      WorkJournalMatrix: 'Matrix del diario de trabajo',
      WorkJournalDrill: 'Simulacro del diario de trabajo',
      WorkJournalProduct: 'Producto del diario de trabajo',
      WorkJournalRegion: 'Región del diario de trabajo',
      Logout: 'Cerrar sesión',
      GpsPosition: 'Posición GPS',
      Update: 'Actualización',
      Meter: 'Metro',
      WorkStart: 'Inicio de la tarea',
      WorkEnd: 'Fin de la tarea',
      Assigned: 'Asignada',
      All: 'Todas',
      AssignedWork: 'Tareas asignadas',
      Comment: 'Comentario',
      Pause: 'Pausa',
      Done: 'Hecho',
      TakeOrder:'Aceptar proyecto',
      StartWork: 'Iniciar tarea',
      SelectWork: 'Seleccionar tarea',
      SelectGeoRegion: 'Seleccionar región geográfica',
      Finish: 'Detener',
      WorkStarted: 'Tarea iniciada',
      WorkEnded: 'Tarea finalizada',
      NoConnection:'No ha sido posible conectar, no se ha finalizado la tarea',
      GpsError: 'Error de GPS. Compruebe que el GPS está conectado.',
      EndWork: 'Detener tarea',
      Stop: 'Detener',
      Finish: 'Finalizado',
      WorkJournal: 'Diario de trabajo',
      HourMin5: 'Hora:Minuto (+5)',
      Field: 'Parcela',
      Fields: 'Parcelas',
      Task: 'Actividad',
      EventJournal: 'Diario del evento',
      Edit: 'Editar',
      Delete: 'Eliminar',
      Duplicate: 'Duplicar',
      EditWork: 'Editar tarea',
      Save: 'Guardar',
      WorkChanged: 'Entrada actualizada',
      DeleteEntry:'Entrada eliminada',
      DeleteEntryQuestion:'¿Desea eliminar esta entrada?',
      EntryDeleted: 'Entrada eliminada',
      WorkDuplicated: 'Tarea duplicada',
      NewEntrys: 'Nuevas entradas',
      NewEntry: 'Nueva entrada',
      Map: 'Mapa',
      FullScreen: 'Pantalla completa',
      Close: 'Cerrar',
      EditEvent: 'Editar evento',
      ProcessEvent: 'Procesar evento',
      EventTime: 'Tiempo del evento',
      EventType: 'Tipo de evento',
      MarkAsProcessed:'Marcar como procesado',
      Cancel: 'Cancelar',
      DateTime: 'Fecha hora',
      Picture: 'Imagen',
      QrScan: 'Escaner QR',
      Summary: 'Resumen',
      PeriodOfTime: 'Periodo de tiempo',
      Month: 'Mes',
      Week: 'Semana',
      Day: 'Día',
      CurrentWeek: 'Semana actual',
      DaysOfWeek: 'Lu,Ma,Miér,Jue,Vier,Sáb,Dom',
      CurrentOrders:'Proyectos abiertos',
      LastOrders: 'Últimos proyectos terminados',
      Created: 'Creado',
      Work: 'Tarea',
      People: 'Personas',
      EnterNewOrders: 'Introducir nuevos proyectos',
      Product: 'Producto',
      Work: 'Tareas',
      OrderDistributed: 'Distribuir proyectos',
      WorkResourcesDefineManage: 'Definir y gestionar tareas y recursos',
      WorkResourceEdit: 'Editar tarea o recurso',
      Description: 'Descripción',
      NoAssignableWork: 'No hay tareas para asignar (recursos)',
      CostFix: 'Costes fijo',
      CostHa: 'Costes hectáreas',
      CostHour: 'Costes por hora',
      DefineNewWorkResource: 'Introducir nueva tarea o recurso',
      Under: 'Bajo',
      ManageEmployees: 'Gestionar empleados',
      EditEmployee: 'Editar empleados',
      InsertEmployee: 'Insertar empleados',
      CurrentEmployees: 'Empleados actuales',
      NewEmployee: 'Nuevo empleado',
      Employee: 'Empleado',
      Employees: 'Empleados',
      Name: 'Apellido',
      NameFirst: 'Nombre',
      Category: 'Categoría',
      Address: 'Dirección',
      HourlyWage: 'Salario por hora',
      MonthlyWage: 'Salario mensual',
      HoursMonth: 'Horas mensuales',
      Active: 'Activo',
      EntryRequired: 'Se necesita indicar entrada',
      InvalidEmail: 'Correo electrónico no válido',
      NotSafeEnugh: 'No es lo suficientemente segura',
      EmailAlreadyRecorded:'Este correo ya se ha registrado',
      ManageProducts: 'Gestionar productos',
      ManageEventTypes: 'Gestionar tipos de evento',
      NewProduct: 'Nuevo producto',
      NewProductGroup: 'Nuevo grupo de productos',
      NewEventType: 'Nuevo tipo de eventos',
      OldPassword: 'Contraseña antigua',
      NewPassword: 'Contraseña nueva',
      NewPasswordRepeat: 'Repetir contraseña nueva',
      PasswordNotEqual:'Las contraseñas no coinciden',
      PasswordUpdated: 'Contraseña actualizada',
      OldPasswordNotValid: 'La contraseña antigua no es válida',
      ShowAll:'Mostrar todo',
      EditGeoRegion: 'Editar región geográfica',
      GeoRegionType: 'Tipo de región geográfica',
      Ground: 'Terreno',
      PlantingYear: 'Año de plantación',
      PlantDistanceMeter: 'Distancia entre plantas (metros)',
      RowsWidthMeters: 'Grosor de las filas (metros)',
      PlantsCapital: 'Capital en plantas',
      AmortizationYear: 'Año de amortización',
      EditGeoRegionMap: 'Editar región geográfica en el mapa',
      NewSubGeoRegion: 'Añadir nueva subregión geográfica',
      NewGeoRegion: 'Nueva región geográfica',
      DrawOnMap: 'Dibujar en mapa',
      Unfinished: 'No terminado',
      Processed: 'Procesado',
      By: 'Por',
      ProcessedBy: 'Procesado por',
      ProcessedComment: 'Comentario procesado',
      ResourceTemlate: 'Plantilla de recursos',
      NewResourceTemlate: 'Nueva plantilla de recursos',
      ResourceTemplateList: 'Plantillas de recursos',
      AllocableWork: 'Tareas asignables',
      Resource: 'Recurso',
      Workgroup: 'Grupo de trabajo',
      PerWorkEntry: 'Entrada por tarea',
      PerAssignment: 'Por proyecto',
      PerDay: 'Por 24 horas',
      WorkReport: 'Informe de trabajo',
      ResourceReport: 'Informe de recursos',
      EnterYield: 'Introducir producción',
      HarvestReorded:'Se ha registrado la cosecha',
      Quantity: 'Kilos',
      Quality: 'Calidad',
      Date: 'Fecha',
      SelectField: 'Seleccionar parcela',
      Hectare: 'Hectárea',
      Percent: 'Porcentaje',
      Total: 'Total',
      YieldJournal: 'Diario de producción',
      ThisMonth: 'Mes actual',
      PreviousMonth: 'Mes anterior',
      NextMonth: 'Mes siguiente',
      EmployeeJournal: 'Diario de empleado',
      DistributionWeightFactor: 'Factor de distribución de peso',
      WeightFactor: 'Factor de distribución',
      CostBill: 'Geo Factura de costes',
      CostBillProduct: 'Producto Factura de costes',
      RecalculateRedistribute: 'Recalcuar y redistribuir',
      AllProducts: 'Todos los productos',
      OrderJournal: 'Diario de proyectos',
      CloseTask:'Cerrar proyecto',
      CloseTaskQuestion:'¿Desea cerrar este proyecto?',
      ReopenTask:'Reabrir tarea',
      ReopenTaskQuestion:'¿Desea cerrar este proyecto?',
      Open: 'Abierto',
      Completed: 'Cerrado',
      DuplicateGeoregions: "Duplicar región geográfica",
      NewName: "Nuevo nombre",
      Duplicate: "Duplicar",
      GeoregionsDuplicated: "Región geográfica duplicada",
      ProductGroup: "Grupos de producto",
      Remove: "Eliminar",
      AssignedProducts: "Productos asignados",
      AssignProduct: "Asignar producto",
      Assign: "Asignar",
      French: "Francés",
      Italian: "Italiano",
      Spanish: "Español",

      InstallExplain: "Esta app puede ser instalada en tu PC o dispositivo móvil, podrás verla y usarla como cualquier otra aplicación instalada.",
      InstallHeader: "Instala en tu PC o dispositivo móvil",
      InstallButtonText: "Installar App",
      InstallIosInfotext: "Toque el botón compartir y luego 'Agregar a Pantalla de Inicio'",

      AddOverlay: 'Agregar Overlay',
      RemoveOverlay: 'Quitar Overlay',
      MapSettingsSaved: 'Se guardó la configuración del mapa',
      ResourceCostFlexible: 'Costos de recursos flexibles',

      ExcelAnalytics: "Excel - Analítica",
      ExcelMobileMessage: "Excel Analítica se basa en las tablas dinámicas de Excel. Desafortunadamente no funcionan bien en las versiones móviles de Excel. Para usar estas funciones, utilice un navegador web de escritorio.",
      ExcelReports: "Informes de Excel",
      UploadExcelTemplate: "Cargar nueva plantilla de Excel",
      DownloadExcel: "Descargar Excel",
      Yield: "Yield",
      NewExcelReportName: "New Excel Report Name",
      DeleteExcelTemplate: "Delete this Excel Template",
      ExcelTemplateDeleted: "Plantilla de Excel eliminado",
      DeleteExcelTemplateQuestion: "Quieres eliminar esta plantilla de Excel?",
      UploadOk: "La plantilla se ha instalado, se puede seleccionar y ejecutar ahora.", 

    }
  }
}